import {Component, Input, OnInit} from '@angular/core';
import {Sponsor} from '@shared/models/sponsor';
import {ImageService} from '@utils/services/image/image.service';
import {IMAGE_RESOLUTION} from '@api/models/image/image-resolution';
import {ImageSubType} from '@api/models/image/image-type';

@Component({
  selector: 'app-news-sponsor-card',
  templateUrl: './news-sponsor-card.component.html',
  styleUrls: ['./news-sponsor-card.component.scss']
})
export class NewsSponsorCardComponent implements OnInit {

  @Input() public sponsor: Sponsor;
  @Input() public sponsorRole;
  public resizedImageSrc: string;

  public ngOnInit(): void {
    if (this.sponsor == null) {
      return;
    }
    this.resizedImageSrc = ImageService.findPictureUrlBySubType(
      this.sponsor.pictures, ImageSubType.IMAGE, IMAGE_RESOLUTION.MEDIUM);
  }

}
